import { Icon, type IconProps } from "./icon";

/** Templates: a sheet with its corner turned and lines set on it. */
export function TemplatesIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M5.25 2.75h6.25l3.25 3.25v11.25h-9.5zM11.5 2.75V6h3.25M7.75 10h4.5M7.75 13h4.5" />
    </Icon>
  );
}
